import React from 'react';
import { MapPin, Check } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../utils/mockData';

const ServiceAreas = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <section id="service-areas" className="py-20 bg-gradient-to-b from-slate-50 to-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4" style={{ fontFamily: 'Arial, sans-serif' }}>
              {t.serviceAreas.title}
            </h2>
            <p className="text-xl text-slate-600 mb-6">
              {t.serviceAreas.subtitle}
            </p>
            <div className="w-24 h-1 bg-amber-600 mx-auto"></div>
          </div>

          {/* Content */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Map Image */}
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="https://images.unsplash.com/photo-1524661135-423995f22d0b?w=800&q=80"
                alt="Los Cabos Map"
                className="w-full h-96 object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 to-transparent flex items-end p-8">
                <div>
                  <div className="flex items-center space-x-2 text-white mb-2">
                    <MapPin className="h-6 w-6 text-amber-400" />
                    <span className="text-2xl font-bold">Los Cabos, B.C.S.</span>
                  </div>
                  <p className="text-slate-200">
                    {language === 'en' ? 'Serving the entire region' : 'Sirviendo toda la región'}
                  </p>
                </div>
              </div>
            </div>

            {/* Areas List */}
            <div>
              <p className="text-lg text-slate-700 mb-8 leading-relaxed">
                {t.serviceAreas.description}
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {t.serviceAreas.areas.map((area, index) => (
                  <div 
                    key={index}
                    className="flex items-center space-x-3 bg-white p-4 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-200 border border-slate-100"
                  >
                    <div className="flex-shrink-0">
                      <div className="w-8 h-8 rounded-full bg-amber-100 flex items-center justify-center">
                        <Check className="h-5 w-5 text-amber-600" />
                      </div>
                    </div>
                    <span className="text-slate-700 font-medium">{area}</span>
                  </div>
                ))}
              </div>

              {/* CTA */}
              <div className="mt-10 p-6 bg-gradient-to-r from-amber-600 to-amber-700 rounded-xl shadow-lg">
                <p className="text-white text-lg font-semibold mb-3">
                  {language === 'en' 
                    ? "Not sure if we service your area?" 
                    : "¿No estás seguro si cubrimos tu área?"}
                </p>
                <p className="text-amber-50 mb-4">
                  {language === 'en' 
                    ? "Contact us! We're always expanding our service reach." 
                    : "¡Contáctanos! Siempre estamos expandiendo nuestra cobertura."}
                </p>
                <button 
                  onClick={() => document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' })}
                  className="bg-white text-amber-600 px-6 py-3 rounded-lg font-bold hover:bg-slate-50 transition-colors duration-200 shadow-md"
                >
                  {language === 'en' ? 'Get in Touch' : 'Ponte en Contacto'}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceAreas;
